import { Col } from 'antd';
import logo2 from 'assets/newlogo.svg';
// import { ReactComponent as LogoSvg } from 'assets/suffix-logo.svg';
import { LoginForm } from 'features/auth/components';

// import { useTranslation } from 'react-i18next';
// import { colors } from 'styles';
import { StyledBackground, StyledCard, StyledRow } from './login.styles';

export const LoginView = () => {
  // const { t } = useTranslation();

  return (
    <StyledBackground align='middle' justify='center' className='sctn_login'>
      <Col xs={24} sm={18} md={12} lg={8}>
        <div className='lgn_logo'>
          <img src={logo2} alt="" />
        </div>
        <StyledCard className='sl_bx'>
          {/* <StyledRow justify='center'>
            <Col>
              <LogoSvg
                title={t('li3ibLogo')}
                color={colors.redBright}
                width={126}
                height={39}
              />
            </Col>
          </StyledRow> */}

          <StyledRow className='slb_rw'>
            <Col xs={24} className='slbr_clm'>
              <LoginForm />
            </Col>
          </StyledRow>

          {/* <Row justify='center'>
            <Col>
              <Space direction='vertical' align='center'>
                <img src={KuwaitFlag} alt={t('login.flagDescription')} />
                <Typography.Text type='secondary'>
                  {t('login.countryDescription')}
                </Typography.Text>
              </Space>
            </Col>
          </Row> */}
        </StyledCard>
      </Col>
    </StyledBackground>
  );
};
